import { PropTypes } from "prop-types";
import CohortDataGrid from "../components/CohortDataGrid/CohortDataGrid";
import Main from "../components/Layout/Main/Main";
import CsvPicker from "../components/CsvPicker/CsvPicker";

const propTypes = {
  cohorts: PropTypes.arrayOf(PropTypes.any).isRequired,
  updateCohortsStates: PropTypes.func.isRequired,
};

const Admin = ({ cohorts, updateCohortsStates }) => {
  return (
    <Main>
      <CsvPicker />
      <CohortDataGrid
        cohorts={cohorts}
        updateCohortsStates={updateCohortsStates}
      />
    </Main>
  );
};

Admin.propTypes = propTypes;

export default Admin;
